import { useEffect, useState } from 'react'

import { HIERARCHY_TYPE_MANDATORY_HP_ROLE_LIST, IContact } from 'clickNgo/entities/contact'
import { IPartner } from 'clickNgo/entities/partner/models'
import { checkHierarchyTypeWithMandatoryContactHPRoles } from 'clickNgo/helpers/validation'
import { checkMandatoryHpRoles } from 'clickNgo/helpers/validation'

interface IUseCheckMandatoryHPRoles {
  contacts: IContact[]
  partner: IPartner
}

export const useCheckMandatoryHpRoles = ({ contacts, partner }: IUseCheckMandatoryHPRoles) => {
  const [mandatoryRoles, setMandatoryRoles] = useState(HIERARCHY_TYPE_MANDATORY_HP_ROLE_LIST)

  const isHierarchyTypeWithMandatoryContactHPRoles = checkHierarchyTypeWithMandatoryContactHPRoles(
    partner.hierarchyType
  )

  useEffect(() => {
    if (isHierarchyTypeWithMandatoryContactHPRoles) {
      setMandatoryRoles(() =>
        checkMandatoryHpRoles(contacts, HIERARCHY_TYPE_MANDATORY_HP_ROLE_LIST)
      )
    } else {
      setMandatoryRoles([])
    }
  }, [contacts, isHierarchyTypeWithMandatoryContactHPRoles])

  return { mandatoryRoles }
}
